import StyledDiv from 'components/StyledDiv';
import * as React from 'react';
export default {
  StyledDiv,
  React
};